<style lang="scss" scoped>
.nav-wrapper{
  // width: 89px;
  position: fixed;
  right: 0;
  bottom: 120px;
  cursor: pointer;
  
  ul{
    li, a{
      display: block;
      // width:89px;
      white-space: nowrap;
      height:40px;
      padding: 0 8px 0 16px;
      background:linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(239,245,255,1) 88%,rgba(203,222,249,1) 100%);
      box-shadow:1px 1px 2px 0px rgba(255,255,255,0.5);
      border-radius:100px 0px 0px 100px;
      margin-bottom: 4px;
      font-size:13px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(69,72,77,1);
      line-height:40px;
      @media screen and (max-width: 1500px ) {
        height: 36px;
        line-height:36px;
        font-size:13px;
        padding: 0 8px 0 16px;
        margin-bottom: 4px;
      }
      &:hover{
        background:linear-gradient(180deg,rgba(252,214,68,1) 0%,rgba(248,167,22,1) 100%);
        box-shadow:1px 1px 2px 0px rgba(255,255,255,0.5);
      }
      &.pitch{
        background:linear-gradient(180deg,rgba(252,214,68,1) 0%,rgba(248,167,22,1) 100%);
        box-shadow:1px 1px 2px 0px rgba(255,255,255,0.5);
      }
    }
  }
}
</style>

<template>
  <div class="nav-wrapper">
    <ul>
      <!-- :class="{'pitch': activethree}" -->
      <li @click="gotoTag('body', 50, 1000, statistics('2019BTS_pc_side_top_click'))">回到顶部</li>
      <li @click="gotoTag('#buy', 50, 600, statistics('2019BTS_pc_side_buy_click'))">{{titleList[0]}}</li>
      <li @click="gotoTag('#show', 50, 600, statistics('2019BTS_pc_side_share_click'))">{{titleList[1]}}</li>
      <li @click="gotoTag('#lottery', 50, 600, statistics('2019BTS_pc_side_luckydraw_click'))">{{titleList[2]}}</li>
      <li @click="shareWb">立即分享</li>
      <li @click="openLink">下载APP</li>
    </ul>
  </div>
</template>

<script>
import shareWeibo from './../assets/js/share-weibo';
export default {
  methods: {
    // n--元素  p--偏移量  t--过渡时间 
    gotoTag(node,skewing,time,fn){
      let Y = document.querySelector(node).offsetTop;
      this.$('html,body').stop().animate({scrollTop: Y - skewing +'px'}, time);
      fn ? fn() : false;
    },
    statistics(code) {
      this.$http.statItemClick({actCode: this.$str('actCode'), clickCode: code}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}});
    },
    shareWb() {
      this.$http.statItemClick({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_side_shareweibo_click'}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}});
      shareWeibo();
    },
    openLink() {
      this.$http.statItemClick({actCode: this.$str('actCode'), clickCode: '2019BTS_pc_side_downloadfeng_click'}, {headers: {'X-ACCESS-TOKEN': localStorage.getItem('token')}});
      window.open('https://apps.apple.com/cn/app/%E5%A8%81%E9%94%8B%E6%96%B0%E7%89%88%E7%A4%BE%E5%8C%BA/id1411932809')
    }
  },
  data() {
    return{
      activeone: true,
      activetwo: false,
      activethree: false,
      titleList: [],
    }
  },
  mounted () {
    this.$bus.on('blockTitleData', (data) => {
      this.titleList = data;
    });
  }
  /* mounted() {
    this.clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    this.showOrderoffsetTop = this.$('#show')[0].offsetTop - this.clientHeight * 2 /3;
    this.LotteryoffsetTop = this.$('#lottery')[0].offsetTop - this.clientHeight * 2 /3;
    this.$(window).scroll(() => {
      let scrollTop = this.$(window).scrollTop();
      if(0 <= scrollTop && scrollTop <= this.showOrderoffsetTop){
        this.activeone = true;
        this.activetwo = false;
        this.activethree = false;
      } else if(this.showOrderoffsetTop <= scrollTop && scrollTop <= this.LotteryoffsetTop){
        this.activeone = false;
        this.activetwo = true;
        this.activethree = false;
      } else if(scrollTop >= this.LotteryoffsetTop){
        this.activeone = false;
        this.activetwo = false;
        this.activethree = true;
      }
    })
  } */
}
</script>



// WEBPACK FOOTER //
// src/blocks/Nav.vue